import styled from 'styled-components';
import breakpoint from '../breakpoints';
const trackingToLetterSpacing = (spacing) => `${spacing / 1000}em`;

export const Wrapper = styled.section`
  border-bottom: 1px solid #ccc;
  width: 90%;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-bottom: 65px;
  padding-top: 35px;
  justify-content: center;
  ${breakpoint('mobile', 'down')}{
    padding-top: 0;
    padding-bottom: 25px;
  } 
`
export const MobileHeadingSection = styled.div`
  margin-bottom: 15px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
  }
`
export const MobileContent = styled.div`
`

export const Heading = styled.div`
  display: flex;
  padding: 30px 0 0 0;
  align-self: center;
  ${breakpoint('mobile', 'down')} {
    flex-direction: column-reverse;
  }
`

export const HeadingImage = styled.div`
flex: 0 0 calc(50% - 25px);
img {
  width: 100%;
}
`

export const HeadingContent = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
flex: 0 0 calc(50% - 50px);
padding: 0 25px
${breakpoint('mobile')}{
  flex: 1 1 100%;
}
`

export const FacilitiesSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  ${breakpoint('mobile', 'down')}{
    margin: auto;
    flex-direction: column;
    align-self: center;
  }
`
export const FacilityRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 20px 20px 0 20px;
  ${breakpoint('mobile', 'down')}{
    padding: 0;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
  }
  ${breakpoint('mobile')}{
    padding-right: 10px;
  }
`

export const Facility = styled.div`
  padding: 20px 0 0 20px;
  margin: 0 15px;
  flex: 0 0 calc(33.3333% - 50px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    height: 80%;
    border-right: 1px solid #ccc;
    ${({ie}) => {
      if (ie === "true") {return 'border-right: none;'}
    }}
    left: 0;
  }
  &:last-child {
    border-right: none;
  }
  &:first-child:after {
    border-right: none;
  }
  ${breakpoint('mobile', 'down')}{
    padding: 10px 0 20px 0;
    margin: 0;
    width: 100%;
    &:after{
      display: none
    }
  }
`

export const FacilityTitle = styled.h3`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-align: center;
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 10px;
  ${breakpoint('mobile', 'down')}{
    align-self: center;
    margin: 0;
    text-transform: capitalize;
  }
`

export const FacilityLink = styled.a`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-decoration: underline;
  padding: 10px;
  color: #CC0000;
  margin-top: auto;
  &:hover {
    color: #990000;
  }
  ${breakpoint('mobile', 'down')}{
    margin: 0;
    align-self: center;
    padding: 0;
    font-size: 14px;
  }
`

export const DescriptionMobile = styled.span`
  ${breakpoint('mobile', 'down')}{
    font-family: 'ToyotaType Book';
    letter-spacing: ${trackingToLetterSpacing(50)};
    text-align: center;
    font-size: 13px;
    line-height: 18px;
    display: inline-block;
    text-align: left;
    padding-top: 10px;
    padding-bottom: 10px;
    ${({ie}) => {
      if (ie === "true") {return 'width: 100%;'}
    }}
  }
`


export const DescriptionText = styled.span`
  font-family: 'ToyotaType Book';
  letter-spacing: ${trackingToLetterSpacing(50)};
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  ${({ie}) => {
    if (ie === "true") {return 'width: 100%;'}
  }}
  ${breakpoint('mobile', 'down')}{
    display: inline-block;
    padding-top: 10px;
    text-align: center;
    padding-bottom: 10px;
  }
`

export const FacilityDescriptionText = styled.span`
  font-family: 'ToyotaType Book';
  letter-spacing: ${trackingToLetterSpacing(50)};
  text-align: center;
  font-size: 13px;
  line-height: 18px;
  ${({ie}) => {
    if (ie === "true") {return 'width: 100%;'}
  }}
  ${breakpoint('mobile', 'down')}{
    display: inline-block;
    padding-top: 10px;
    text-align: center;
    padding-bottom: 10px;
  }
`

export const HeadingText = styled.h3`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
`
export const HeadingContentMobile = styled.h3`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  text-align: center;
  letter-spacing: ${trackingToLetterSpacing(0)};
  font-size: 18px;
  line-height: 32px;
  padding-top:20px;
`